import React from 'react';
import ImagePreview from './ImagePreview';

const ChatInput = ({ 
  input, 
  setInput, 
  handleSend, 
  isSending, 
  hasStartedChat, 
  waitingForOutcome, 
  selectedImages, 
  imagePreview, 
  removeImage, 
  fileInputRef,
  fileUploadRef, 
  handleFileSelect,
  handleImageSelect,
  handleFileUpload, 
  isSidebarVisible 
}) => {
  return (
    <div className={`chat-input-wrapper ${imagePreview.length > 0 ? 'has-images' : ''}`}>
      <div className={`chat-input-container ${
        !hasStartedChat 
          ? "initial" 
          : `moving-to-bottom ${isSidebarVisible ? "shifted" : ""}`
      }`}>
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />
        
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageSelect}
          style={{ display: 'none' }}
          id="image-upload"
        />
        
        <input
          ref={fileUploadRef}
          type="file"
          accept=".csv,image/*"
          multiple
          onChange={handleFileUpload}
          style={{ display: 'none' }}
        />
        
        <ImagePreview 
          imagePreview={imagePreview} 
          removeImage={removeImage} 
        />
        
        <div className="input-controls-row">
          <div className="upload-btn-container">
            <button
              onClick={() => fileUploadRef.current?.click()}
              className="upload-btn"
              disabled={isSending}
            >
              <i className="fas fa-paperclip"></i>
            </button>
            <span className="upload-tooltip">Upload Files</span>
          </div>

          <textarea
            className="chat-input"
            placeholder={
              !hasStartedChat 
                ? "Upload files or ask a question to get started..." 
                : waitingForOutcome 
                  ? "Which variable would you like to predict?" 
                  : "Type your message..."
            }
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                if (!isSending) handleSend();
              }
            }}
            disabled={isSending}
            rows={1}
          />
          
          <div className="input-separator"></div>
          
          <button 
            className="chat-send-btn" 
            onClick={handleSend} 
            disabled={isSending || (input.trim() === "" && selectedImages.length === 0)}
          >
            <i className="fas fa-arrow-up"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;
